<template>
  <v-card class="elevation-12 ma-auto" max-width="700px">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ headerText }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form id="login-form" @submit.prevent="submit">
        <v-text-field
          :value="username"
          @change="val => { username = val }"
          v-validate="'required'"
          prepend-icon="person"
          name="username"
          :label="$t('LOGIN_OR_EMAIL')"
          type="text"
          autofocus
          :disabled="usernameDisabled"
        >
        </v-text-field>
        <v-text-field
          v-model="password"
          v-validate="'required'"
          prepend-icon="lock"
          name="password"
          :label="$t('PASSWORD')"
          id="password"
          type="password"
        >
        </v-text-field>
        <v-select
          v-if="cadences.length > 1"
          v-model="select"
          :items="cadences"
          prepend-icon="storage"
          label="Kadencja"
        >
        </v-select>
        <div class="error--text" v-if="isError">
          <span>{{ error ? error : $t('LOGIN_EMAIL_OR_PASSWORD_INCORRECT') }}</span>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="isFormValid || submitting"
            :loading="submitting"
            form="login-form"
            color="primary"
            type="submit"
          >
            {{ $t('LOGIN') }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import { AuthService } from '@/utils/services/auth-service';

  export default {
    name: 'LoginForm',
    props: {
      isError: Boolean,
      error: String,
      headerText: String,
      submitting: Boolean,
    },
    data() {
      return {
        select: 'default',
        username: null,
        password: null,
        usernameDisabled: false,
        cadences: [],
      };
    },
    computed: {
      ...mapState('auth', ['login']),

      isFormValid() {
        return Object.keys(this.fields).some(key => !this.fields[key].valid);
      },
    },
    created() {
      AuthService.cadences().then(res => {
        this.cadences = res.data;
        this.cadences.unshift({ text: 'Aktualna', value: 'default' });
      });
      if (this.login) {
        this.username = this.login;
        this.usernameDisabled = true;
      }
    },
    methods: {
      submit() {
        this.$emit('submit', { username: this.username, password: this.password, cadence: this.select });
      },
    },
  };
</script>
